
export const set_to_sessionStorage = (key, data) => {
    if (typeof data === "object") {
      sessionStorage.setItem(key, JSON.stringify(data));
    } else {
      sessionStorage.setItem(key, data);
    }
  };
  
  export const get_from_sessionStorage = (key) => {
    let parsed = undefined;
    let parse_success = true;
    try {
      parsed = JSON.parse(sessionStorage.getItem(key));
    } catch (error) {
      parse_success = false;
    }
    if (!parse_success) {
      let item = sessionStorage.getItem(key);
      return item;
    }
    return parsed;
  };
  
  export const del_from_sessionStorage = (key) => {
    let item = sessionStorage.getItem(key);
    if (item) {
      sessionStorage.removeItem(key);
    } else {
      console.error("item not found");
    }
  };
  